"use strict";
/****************************************************
 * Audit Information Platform Component
 * 包含表的参照项目组件
 * 2020-08
 * Sunny <tufpsj@yonyou.com>
 ****************************************************/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
//----- Global ------
var React = require("react");
//----- iUAP ------
var ref_multiple_table_1 = require("ref-multiple-table");
require("ref-multiple-table/lib/index.css");
//----- AIP ------
var RefItem_1 = require("./RefItem");
var Message_1 = require("./Message");
var Const_1 = require("./Const");
var types_1 = require("../types");
var utils_1 = require("../utils");
/**
 * 表格参照组件
 *
 * 弹出表格组件
 */
var TableRef = /** @class */ (function (_super) {
    __extends(TableRef, _super);
    function TableRef() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showLoading: false,
            showModal: false,
            matchData: _this.props.matchData || [],
            value: '',
            valuefield: _this.props.valuefield,
            displayfield: _this.props.displayfield,
            inputDisplay: '{refname}',
            key: 'primarykey',
            tableData: [], // 当前显示的记录
        };
        _this.page = {
            pageCount: 0,
            pageSize: 1000,
            currPageIndex: 1,
        };
        _this.columnsData = [];
        _this.allData = null; // 返回的全部记录
        _this.filterData = null; // 过滤的数据集合
        _this.paginationProps = {
            first: true,
            last: true,
            prev: true,
            next: true,
            maxButtons: 5,
            boundaryLinks: true,
            dataNum: 0,
            dataNumSelect: [types_1.PAGE_LIMIT],
            showJump: false,
        };
        _this.options = {
            miniSearch: true,
            multiple: _this.props.multiple !== '0',
            emptyBut: true
        };
        /**
         * 构建分页数据
         * @function
         * @param {RecordData[] | null | undefined} datas
         * @returns {PageResult}
         */
        _this.buildPage = function (datas) {
            var dts = datas || [];
            var pc = Math.floor((dts.length + (types_1.PAGE_LIMIT - 1)) / types_1.PAGE_LIMIT);
            return {
                pageCount: pc,
                currPageIndex: 1,
                totalElements: dts.length || 0
            };
        };
        /**
         * 远程请求数据
         * @function
         * @param {StringStringMap} params
         * @param {string} defaultValue
         */
        _this.loadData = function (params, defaultValue) {
            var _a;
            _this.allData = null;
            var getData = _this.props.loadData;
            var refId = _this.props.refId || '';
            var itemIndex = (_a = _this.props.itemIndex) !== null && _a !== void 0 ? _a : -1;
            getData(refId, itemIndex, _this.props.dsId, params).then(function (response) {
                var resp = response.data;
                var columnsData = resp.columns;
                _this.allData = resp.data || [];
                var _a = _this.state, valuefield = _a.valuefield, displayfield = _a.displayfield;
                ///dataIndex: "code"
                // key: "code"
                // title: "人员编码
                _this.allData.forEach(function (record, idx) {
                    record.key = record[valuefield] + idx;
                    record.refpk = record[valuefield] + idx;
                    record.refname = record[displayfield];
                });
                _this.filterData = _this.allData;
                _this.launchTableHeader(columnsData);
                _this.setState({
                    showLoading: false,
                    key: 'primarykey' + Math.random(),
                }, function () {
                    _this.handlePagination(1);
                    if (defaultValue) { // 如果有默认值，就设置相应属性
                        var values_1 = [];
                        try {
                            values_1 = defaultValue.split(',');
                        }
                        catch (e) {
                            console.error(e.message);
                        }
                        values_1 = values_1.map(function (val) {
                            if (val.startsWith("'")) {
                                return val.substring(1, val.length - 1);
                            }
                            return val;
                        });
                        var matchs = (_this.allData || []).filter(function (item) {
                            return values_1.includes(item[_this.state.valuefield]);
                        });
                        _this.setState({
                            matchData: matchs,
                            value: utils_1.Utils.getShowFieldValues(matchs, _this.props.displayfield, _this.props.valuefield), //`{"refname":"${matchs[0][this.state.displayField]}", "refpk":"${matchs[0][this.state.valuefield]}"}`, // 仅显示第一项?
                        }, function () {
                            _this.refItemValueChange(_this.getValue());
                        });
                    }
                });
                // fetchCallback = (data, condition, url)
                setTimeout(function () {
                    _this.props.fetchCallback && _this.props.fetchCallback(_this.allData, params, refId, itemIndex);
                }, 200);
            }).catch(function (e) {
                if (!e.message) {
                    if (e !== 'Error') {
                        Message_1.default.showMessage(Const_1.QUERY_ERROR_MSG, 'danger', 5);
                    }
                }
                else {
                    Message_1.default.showMessage(e.message);
                }
                _this.refItemValueChange(null);
            });
        };
        /**
         * 设置默认值 ***override***
         * @function
         * @param {string} value
         */
        _this.setDefaultValue = function (value) {
            // TODO
        };
        /**
         * 根据 refinfo 返回结果拆解并渲染表格表头,注意：单选时候自己添加radio
         * @function
         * @param {string[]} data
         *
         */
        _this.launchTableHeader = function (data) {
            if (!data)
                return;
            var colunms = [];
            data.forEach(function (item) {
                colunms.push({
                    key: item,
                    dataIndex: item,
                    title: item
                });
            });
            if (colunms.length === 0) {
                colunms = [{ title: "未传递表头数据", dataIndex: "nodata", key: "nodata" }];
            }
            _this.columnsData = colunms;
        };
        /**
         * 处理并渲染表格数据
         * @function
         * @param {any[]} records 传入的表格数据
         */
        _this.launchTableData = function (records) {
            if (!records)
                return;
            _this.setState({
                tableData: records,
            }, function () {
            });
            // console.log(this.tableData);
        };
        /**
         * 简单搜索的回调，与复杂搜索的回调不是同一个
         * @function
         * @param {string | null} value
         */
        _this.miniSearchFunc = function (value) {
            if (!value) {
                _this.filterData = _this.allData;
            }
            else {
                var columns = _this.columnsData || [];
                var titleNmaes_1 = [];
                columns.forEach(function (item) {
                    titleNmaes_1.push(item['title']);
                });
                _this.filterData = (_this.allData || []).filter(function (item) {
                    for (var k in item) {
                        if (titleNmaes_1.indexOf(k) >= 0) {
                            var v = "".concat(item[k]);
                            if (v.includes(value)) {
                                return true;
                            }
                            var upper = v.toUpperCase();
                            var lower = v.toLowerCase();
                            if (lower.includes(value) || upper.includes(value)) {
                                return true;
                            }
                        }
                    }
                    return false;
                });
            }
            if (_this.filterData) {
                _this.handlePagination(1);
            }
        };
        /**
         * 跳转到制定页数的操作
         * @function
         * @param {number} index 跳转到页码, start from 0
         */
        _this.handlePagination = function (index) {
            _this.page = _this.buildPage(_this.filterData);
            _this.page.currPageIndex = index;
            var start = (index - 1) * types_1.PAGE_LIMIT;
            var bodyData = (_this.filterData || []).slice(start, start + types_1.PAGE_LIMIT);
            _this.launchTableData(bodyData);
            _this.setState({ number: Math.random() });
        };
        /**
         * 选择每页数据个数
         * @function
         * @param {number} index
         * @param {number} pageSize
         */
        _this.dataNumSelect = function (index, pageSize) {
            // console.log(index, pageSize);
        };
        /**
         * modal框确认按钮
         * @function
         * @param {any} item
         */
        _this.onSave = function (item) {
            _this.setState({
                showModal: false,
                matchData: item,
            }, function () {
                _this.valueChange();
            });
            _this.miniSearchFunc(null);
        };
        /**
         * 将获取的数组数据转为iuap需要的格式
         * @function
         * @param {any[]} items
         * @returns {StringStringMap}
         *
         */
        _this.buildValue = function (items) {
            var result = {};
            items.forEach(function (item) {
                var valuefield = result[_this.state.valuefield];
                if (!valuefield) {
                    result['refpk'] = item[_this.state.valuefield];
                }
                else {
                    result['refpk'] = result['refpk'] + ';' + item[_this.state.valuefield];
                }
                var displayField = result[_this.state.displayfield];
                if (!displayField) {
                    result['refname'] = item[_this.state.displayfield];
                }
                else {
                    result['refname'] = result['refname'] + ';' + item[_this.state.displayfield];
                }
            });
            return result;
        };
        /**
         * 内部方法，在选择值发生变化的时候触发
         * @function
         */
        _this.valueChange = function () {
            _this.refItemValueChange(_this.getValue());
        };
        /**
         * 获取值，按需 **override**
         * @function
         * @returns {string}
         */
        _this.getValue = function () {
            var resultArray = [];
            if (_this.state.matchData) {
                _this.state.matchData.forEach(function (item) {
                    resultArray.push(item[_this.state.valuefield]);
                });
            }
            if (_this.props.multiple === '0') {
                return resultArray[0];
            }
            else if (_this.props.multiple === '1') {
                var tmp = resultArray.map(function (item) {
                    return "'" + item + "'";
                });
                return tmp.join(',');
            }
            else {
                return resultArray.join(',');
            }
        };
        /**
         * modal框右上X和右下角取消
         * @function
         */
        _this.onCancel = function () {
            _this.setState({
                showModal: false,
            });
            _this.miniSearchFunc(null);
        };
        /**
         * 清空操作，借助form。就是value和matchData置空。前者对应input框，matchData对应表中选中的节点
         * @function
         */
        _this.clearFunc = function () {
            function cleanState(self) {
                self.setState({
                    number: Math.random(),
                    matchData: [],
                    value: "{\"refname\":\"\",\"refpk\":\"".concat(Math.random(), "\"}"),
                }, function () {
                });
            }
            if (_this.props.itemIndex === 0) {
                cleanState(_this);
            }
            else {
                _this.allData = null;
                _this.filterData = null;
                _this.launchTableData([]);
                cleanState(_this);
            }
        };
        /**
         * 清空操作 ***override***
         * @function
         */
        _this.clear = function () {
            _this.clearFunc();
        };
        return _this;
    }
    TableRef.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        this.setState({
            valueField: nextProps.valuefield,
            displayfield: nextProps.displayfield
        }, function () {
        });
    };
    TableRef.prototype.render = function () {
        var _a = this.state, showLoading = _a.showLoading, showModal = _a.showModal, matchData = _a.matchData, value = _a.value, valuefield = _a.valuefield, inputDisplay = _a.inputDisplay, displayfield = _a.displayfield;
        var _b = this, columnsData = _b.columnsData, page = _b.page;
        var childrenProps = Object.assign({}, this.options, __assign(__assign({ showModal: showModal, showLoading: showLoading, columnsData: columnsData }, page), { matchData: matchData, value: value, 
            // searchFilterInfo: this.searchFilterInfo,
            miniSearchFunc: this.miniSearchFunc, dataNumSelect: this.dataNumSelect, handlePagination: this.handlePagination, onSave: this.onSave, onCancel: this.onCancel }));
        return (React.createElement(ref_multiple_table_1.RefMultipleTableWithInput, __assign({ key: this.state.key }, childrenProps, { backdrop: this.props.backDrop, dropdownDisabled: true, tableProps: { scroll: { y: 500 } }, tableData: this.state.tableData, modalProps: { draggable: true, needScroll: true }, paginationProps: this.paginationProps, style: { width: this.props.width || 200 }, valueField: valuefield, inputDisplay: inputDisplay, displayField: displayfield, title: (0, utils_1.getTranslate)(null, this.props.label || this.props.name) })));
    };
    return TableRef;
}(RefItem_1.default));
exports.default = TableRef;
